/**
 * Create a deep link from the current full URL.
 */
export function convertToDeeplink(url: string) {
  if (!url) return "";
  const encoded = encodeURIComponent(url);
  return `https://m9wvy.app.goo.gl/?apn=jp.co.joyz.terratalk&ibi=jp.co.joyz.TerraTalk&isi=1114037031&link=${encoded}`;
}
